'use strict'

import {jsonrpc} from 'Common/jsonrpc'
import {emailService} from './email-service'

function jnxServices (Vue) {
	if (jnxServices.installed) {
		return
	}

	if (typeof Vue.http !== 'undefined') {
		//
		// Adding jsonrpc and common services under e24Common
		//
		Vue.http.jsonrpc = jsonrpc(Vue.http, Vue.prototype.$Progress)

		//
		// Exposing common services
		//
		Vue.jnx = {
			emailService: emailService(Vue.http)
		}
	} else {
		console.error('To install the jsonrpc plugin it is necessary to have vue-resource in advance')
	}
}

if (typeof window !== 'undefined' && window.Vue) {
	window.Vue.use(jnxServices)
}

export default jnxServices
